import React from 'react';

interface noProjectProps {
    message?: string;
};

const NoProjectAccess: React.FC<noProjectProps> = ({ message }) => {
    return (
        <div className='flex justify-center items-center w-full h-screen text-neutral-25'>
            <p className='text-neutral-25 text-lg font-bold'>{message}</p>
            {message && <button>
                <a href="/dashboard" className="text-primary-400 ml-2">Go to Dashboard</a>
            </button>}
        </div>
    );
};

export default NoProjectAccess;